/* eslint-disable react/prop-types */
import React from 'react';
import { Badge, Card, CardText } from 'reactstrap';
import moment from 'moment'
import { DefaultTooltipContent } from 'recharts/lib/component/DefaultTooltipContent';
import { setCurrencyFormat } from '../../utils/helpers';

export const sortType = ((rowA, rowB, id, desc) => {
    let itemA = Number(rowA.original?.[id]?.toString().replace(/[&/\\#,+()$~%'":*?<>{}]/g, ''));
    let itemB = Number(rowB.original?.[id]?.toString().replace(/[&/\\#,+()$~%'":*?<>{}]/g, ''));

    if (Number.isNaN(itemA)) {  // Blanks and non-numeric strings to bottom
        itemA = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    }
    if (Number.isNaN(itemB)) {
        itemB = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    }

    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(itemA)) {
        if (itemA > itemB) return 1;
        if (itemB > itemA) return -1;
        // eslint-disable-next-line no-restricted-globals
    }

    // eslint-disable-next-line no-restricted-globals
    if (rowA?.original?.[id] && isNaN(rowA.original?.[id])) {
        return rowA.original?.[id].localeCompare(rowB.original?.[id])
    }

    return 0;
})

export const vendorNameMapping = {
    amazon: 'Amazon',
    shopify: 'Shopify',
    wholesale: 'Wholesale',
    ebay: 'Ebay'
}

export const tableHeaderDataSales = [
    {
        Header: 'Day',
        accessor: 'day',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 100,
        sortType
    },
    {
        Header: 'Month',
        accessor: 'salesMonth',
        disableGlobalFilter: false,
        width: 100,
        sortType
    },
    {
        Header: 'Year',
        accessor: 'salesYear',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 100,
        sortType
    },
    {
        Header: 'Order',
        accessor: 'orderCount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        sortType
    },
    {
        Header: 'SKU',
        accessor: 'sku',
        disableGlobalFilter: false,
        width: 150,
    },
    {
        Header: 'Amount',
        accessor: 'amount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 130,
        sortType
    },
    {
        Header: 'Product Collection',
        accessor: 'productCollection',
        disableGlobalFilter: false,
        width: 180,
        sortType
    },
    {
        Header: 'Product Category',
        accessor: 'productCategory',
        disableGlobalFilter: false,
        width: 180,
        sortType
    },
    {
        Header: 'Product Sub Category',
        accessor: 'productSubCategory',
        disableGlobalFilter: false,
        width: 200,
        sortType
    },

    {
        Header: 'Sales Channel',
        accessor: 'salesChannel',
        disableGlobalFilter: false,
        width: 180,
        sortType
    },
]

export const aovHeaderData = [{
    Header: 'Day',
    accessor: 'day',
    disableGlobalFilter: false,
    width: 200,
    rightAlign: true,
    sortType
}, {
    Header: 'Average Order Value',
    accessor: 'Average Order Value',
    disableGlobalFilter: false,
    width: 270,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) =>
        // eslint-disable-next-line react/prop-types
        setCurrencyFormat(Number(original['Average Order Value']).toFixed(2), false),
    sortType

}, {
    Header: 'Average Units Per Transaction',
    accessor: 'Average Units Per Transaction',
    disableGlobalFilter: false,
    width: 270,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) =>
        // eslint-disable-next-line react/prop-types
        setCurrencyFormat(Number(original['Average Units Per Transaction']).toFixed(2), false),
    sortType

}]

export const filterShowWise = [{
    label: "Product Collection", value: "productCollection"
}, {
    label: "Product Category", value: "productCategory"
},

{
    label: "Product Sub Category", value: "productSubCategory"
},
{
    label: "SKU Code", value: "sku"
}]

export const isSalesOption = [{
    label: "Sales Amount", value: "amount"
}, {
    label: "Quantity", value: "quantity"
},]

export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const monthWithDays = {
    'Jan': 31, 'Feb': 29, 'Mar': 31, 'Apr': 30, 'May': 31, 'Jun': 30, 'Jul': 31,
    'Aug': 31, 'Sep': 30, 'Oct': 31, 'Nov': 30, 'Dec': 31
}
export const monthWithDaysByNo = {
    '1': 31, '2': 29, '3': 31, '4': 30, '5': 31, '6': 30, '7': 31,
    '8': 31, '9': 30, '10': 31, '11': 30, '12': 31
}

export const saleskey = 'Sales Amount';
export const orderKey = 'Order Count'
export const refundOrderKey = 'Refund Order Count'

export const filterWiseKeyMapping = {
    productCategory: 'Product Category',
    productCollection: 'Product Collection',
    productSubCategory: "Product Sub Category",
    sku: 'SKU Code'
}

export const CustomTooltip = (props) => {
    // eslint-disable-next-line react/prop-types
    const { active, payload, category, categorisedBasedOn } = props;
    // we don't need to check payload[0] as there's a better prop for this purpose
    if (!active) {
        // I think returning null works based on this: http://recharts.org/en-US/examples/CustomContentOfTooltip
        return null
    }
    // mutating props directly is against react's conventions
    // so we create a new payload with the name and value fields set to what we want
    // eslint-disable-next-line react/prop-types
    const data = payload[0]?.payload;
    const newPayload = [
        {
            name: 'Date',
            // all your data which created the tooltip is located in the .payload property
            // eslint-disable-next-line react/prop-types
            value: data?.currentMonthDataKey,
            // you can also add "unit" here if you need it
        },
        {
            name: saleskey,
            value: setCurrencyFormat(data?.[saleskey], true)
        },
        {
            name: orderKey,
            value: setCurrencyFormat(data?.[orderKey], false)
        },
        {
            name: filterWiseKeyMapping?.[categorisedBasedOn],
            value: category
        },
        // ...payload,
    ];

    // we render the default, but with our overridden payload
    return <DefaultTooltipContent {...props} payload={newPayload} />;
};

export const sortByOptions = [{
    value: 'currentYearMonthMax',
    label: 'Amount'
}, {
    value: 'title',
    label: 'Description'
},
]

export const sortByAdvBudgetOptions = [
    {
        value: 'title',
        label: 'Description'
    }, {
        value: 'dailyBudget',
        label: 'Daily Budget'
    }, {
        value: 'sales',
        label: 'Sales'
    }, {
        value: 'cost',
        label: 'Cost'
    },
]

export const colorArr = [
    '#ffe6e6',
    '#ffcccc',
    '#ffb3b3',
    '#ff9999',
    '#ff8080',
    '#ff6666',
    '#ff4d4d',
    '#ff3333',
    '#ff1a1a',
    '#ff0000',
    '#ccffcc',
    '#b3ffb3',
    '#99ff99',
    '#80ff80',
    '#66ff66',
    '#4dff4d',
    '#33ff33',
    '#1aff1a',
    '#00ff00',
    '#00e600',
    '#C0C0C0',
    '#faf9f7'
    // '#ebeae8'
]

export const tableHeaderDataProfit = [
    {
        Header: 'SKU',
        accessor: 'sku',
        disableGlobalFilter: false,
        width: 280,
        // eslint-disable-next-line react/prop-types
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { productName, asin, sku, fbaFeesEst } = original
            return <div>
                <div>{productName}</div>
                <div className="d-flex justify-content-between">
                    <div>
                        <span>{asin}</span><span className="pl-1 pr-2">/</span><span>{sku}</span>
                    </div>
                    <div>
                        {fbaFeesEst ? <Badge color="secondary">FBA</Badge> : null}
                    </div>
                </div>
            </div>
        },
        sortType
    },
    {
        Header: 'Gross Revenue',
        accessor: 'grossRevenue',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 150,
        sortType
    },
    {
        Header: 'Cost',
        accessor: 'cost',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 150,
        sortType
    }, {
        Header: 'FBA Cost (est)',
        accessor: 'fbaFeesEst',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 150,
        sortType
    },
    {
        Header: 'Selling Fee (est)',
        accessor: 'sellingFeesEst',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 150,
        sortType
    },
    {
        Header: 'Net Profit',
        accessor: 'netProfit',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 150,
        sortType
    },
    {
        Header: 'Margin',
        accessor: 'netMargin',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 130,
        sortType
    },
]

export const tableHeaderDataProfitForShopify = [
    {
        Header: 'SKU',
        accessor: 'sku',
        disableGlobalFilter: false,
        width: 280,
        // eslint-disable-next-line react/prop-types
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { productName, asin, sku } = original
            return <div>
                <div>{productName}</div>
                <div className="d-flex justify-content-between">
                    <div>
                        <span>{asin}</span><span className="pl-1 pr-2">/</span><span>{sku}</span>
                    </div>
                </div>
            </div>
        }
    },
    {
        Header: 'Gross Revenue',
        accessor: 'grossRevenue',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 150,
    },
    {
        Header: 'Cost',
        accessor: 'cost',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 150,
    },
    {
        Header: 'Shipping (est)',
        accessor: 'shippingEst',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 150,
    },
    {
        Header: 'Net Profit',
        accessor: 'netProfit',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 150,
    },
    {
        Header: 'Margin',
        accessor: 'netMargin',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 130,
    },
]

export const tableHeaderDataProfitWholesale = [
    {
        Header: 'SKU',
        accessor: 'sku',
        disableGlobalFilter: false,
        width: 280,
        // eslint-disable-next-line react/prop-types
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { productName, asin, sku } = original
            return <div>
                <div>{productName}</div>
                <div className="d-flex justify-content-between">
                    <div>
                        <span>{asin}</span><span className="pl-1 pr-2">/</span><span>{sku}</span>
                    </div>
                </div>
            </div>
        }
    },
    {
        Header: 'Gross Revenue',
        accessor: 'grossRevenue',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 150,
    },
    {
        Header: 'Cost',
        accessor: 'cost',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 150,
    },
    {
        Header: 'Broker (est)',
        accessor: 'brokerEst',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 150,
    },
    {
        Header: 'Net Profit',
        accessor: 'netProfit',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 150,
    },
    {
        Header: 'Margin',
        accessor: 'netMargin',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 130,
    },
]


export const tableHeaderDataMonthlyOrderSub = [
    {
        Header: 'Sales Month',
        accessor: 'salesMonth',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        sortType
    },
    {
        Header: 'Sales Year',
        accessor: 'salesYear',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        sortType
    },
    {
        Header: 'Product Collection',
        accessor: 'productCollection',
        disableGlobalFilter: false,
        width: 180,
        sortType
    },
    {
        Header: 'Product Category',
        accessor: 'productCategory',
        disableGlobalFilter: false,
        width: 180,
        sortType
    },
    {
        Header: 'Product Sub Category',
        accessor: 'productSubCategory',
        disableGlobalFilter: false,
        width: 200,
        sortType
    },

    {
        Header: 'Sales Channel',
        accessor: 'salesChannel',
        disableGlobalFilter: false,
        width: 180,
        sortType
    },
    {
        Header: 'Country',
        accessor: 'country',
        disableGlobalFilter: false,
        sortType
    },
    {
        Header: 'Quantity',
        accessor: 'quantity',
        disableGlobalFilter: false,
        rightAlign: true,
        sortType
    },
    {
        Header: 'Order',
        accessor: 'orderCount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        sortType
    },
    {
        Header: 'Amount',
        accessor: 'amount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 130,
        sortType
    },

]

export const sortBySubscribersOptions = [{
    value: 'currentDateMax',
    label: 'Subscribers'
}, {
    value: 'title',
    label: 'Description'
},
]

export const colorArrRedBlue = [
    '#ffe6e6',
    '#ffcccc',
    '#ffb3b3',
    '#ff9999',
    '#ff8080',
    '#ff6666',
    '#ff4d4d',
    '#ff3333',
    '#ff1a1a',
    '#ff0000',
    '#659EC7',
    '#3090C7',
    '#357EC7',
    '#488AC7',
    '#4682B4',
    '#368BC1',
    '#1E90FF',
    '#1589FF',
    '#157DEC',
    '#306EFF',
    '#C0C0C0',
]

export const filterShowWiseWithoutCollection = [{
    label: "Product Category", value: "category"
},

{
    label: "Product Sub Category", value: "subCategory"
},
{
    label: "SKU Code", value: "sku"
}]

const commonCardForInventory = (text, backgroundColor, color) => <Card body style={{
    background: backgroundColor,
    marginBottom: '0px',
    marginTop: '0px', paddingTop: '3px', paddingBottom: '3px',
    paddingRight: '3px'
}}>
    <CardText style={{
        color: color || '#000000', fontSize: '12px', textAlign: 'right', paddingBottom: '0px',
        paddingTop: '0px', marginBottom: '0px'
    }}>
        {text}
    </CardText>
</Card>

export const tableInventoryFBAForecast = prepareStocks => [
    {
        Header: 'SKU',
        accessor: 'sku',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: true,
        sortType
    },
    {
        Header: 'Sales Channel',
        accessor: 'salesChannel',
        disableGlobalFilter: false,
        width: 150,
        rightAlign: false,
        sortType
    },
    {
        Header: 'FNSKU',
        accessor: 'fnsku',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: true,
        sortType
    },
    {
        Header: 'ASIN',
        accessor: 'asin',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: true,
        sortType
    },
    {
        Header: 'Product Name',
        accessor: 'productName',
        disableGlobalFilter: false,
        width: 230,
        rightAlign: true,
        sortType

    }, {
        Header: 'Available',
        accessor: 'fulFillableQty',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: true,
        sortType,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { fulFillableQty } = original
            return commonCardForInventory(fulFillableQty, '#9392EA')
        }
    },
    {
        Header: 'Inbound Working Qty',
        accessor: 'inboundWorkingQty',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 100,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { inboundWorkingQty } = original
            return commonCardForInventory(inboundWorkingQty, '#FBE4D5')
        },
        sortType
    },
    {
        Header: 'Inbound Shipped Qty',
        accessor: 'inboundShippedQuantity',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 100,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { inboundShippedQuantity } = original
            return commonCardForInventory(inboundShippedQuantity, '#FBE4D5')
        },
        sortType
    },{
        Header: 'Inbound Receiving Qty',
        accessor: 'inboundReceivingQuantity',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 100,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { inboundReceivingQuantity } = original
            return commonCardForInventory(inboundReceivingQuantity, '#FBE4D5')
        },
        sortType
    },
    {
        Header: 'Inbound Total',
        accessor: 'inboundTotal',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { inboundTotal } = original
            return commonCardForInventory(inboundTotal, '#F4B082')
        },
        sortType
    },
    {
        Header: 'Pending Customer Order Qty',
        accessor: 'pendingCustomerOrderQuantity',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { pendingCustomerOrderQuantity } = original
            return commonCardForInventory(pendingCustomerOrderQuantity, '#DEEBF6')
        },
        sortType
    },
    {
        Header: 'Pending Trans Shipment Qty',
        accessor: 'pendingTransShipmentQuantity',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { pendingTransShipmentQuantity } = original
            return commonCardForInventory(pendingTransShipmentQuantity, '#DEEBF6')
        },
        sortType
    },
    {
        Header: 'Fc Processing Qty',
        accessor: 'fcProcessingQuantity',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { fcProcessingQuantity } = original
            return commonCardForInventory(fcProcessingQuantity, '#DEEBF6')
        },
        sortType
    },    
    {
        Header: 'Reserved',
        accessor: 'reserved',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 100,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { reserved } = original;
            return commonCardForInventory(reserved, '#9CC3E6')
        },
        sortType
    },    
    {
        Header: 'Customer Damaged Qty',
        accessor: 'customerDamagedQuantity',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { customerDamagedQuantity } = original
            return commonCardForInventory(customerDamagedQuantity, '#FBE4D5')
        },
        sortType
    },
    {
        Header: 'Warehouse Damaged Qty',
        accessor: 'warehouseDamagedQuantity',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { warehouseDamagedQuantity } = original
            return commonCardForInventory(warehouseDamagedQuantity, '#FBE4D5')
        },
        sortType
    },
    {
        Header: 'Distributor Damaged Qty',
        accessor: 'distributorDamagedQuantity',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { distributorDamagedQuantity } = original
            return commonCardForInventory(distributorDamagedQuantity, '#FBE4D5')
        },
        sortType
    },
    {
        Header: 'Carrier Damaged Qty',
        accessor: 'carrierDamagedQuantity',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { carrierDamagedQuantity } = original;
            return commonCardForInventory(carrierDamagedQuantity, '#FBE4D5')
        },
        sortType
    },
    {
        Header: 'Defective Qty',
        accessor: 'defectiveQuantity',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { defectiveQuantity } = original;
            return commonCardForInventory(defectiveQuantity, '#FBE4D5')
        },
        sortType
    },
    {
        Header: 'Expired Qty',
        accessor: 'expiredQuantity',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { expiredQuantity } = original;
            return commonCardForInventory(expiredQuantity, '#FBE4D5')
        },
        sortType
    },
    {
        Header: 'Unfulfillable',
        accessor: 'unfulfillable',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { unfulfillable } = original;
            return commonCardForInventory(unfulfillable, '#F4B082')
        },
        sortType
    },
    {
        Header: 'Researching',
        accessor: 'researching',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 130,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { researching } = original
            return commonCardForInventory(researching, '#DEEBF6')
        },
        sortType
    },
    {
        Header: 'Total Inventory',
        accessor: 'totalInventory',
        disableGlobalFilter: false,
        width: 180,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { totalInventory } = original;
            return commonCardForInventory(totalInventory, '#9CC3E6')
        },
        sortType
    },
    {
        Header: 'Sold qty (7 days)',
        accessor: 'soldQty7Days',
        disableGlobalFilter: false,
        width: 200,
        rightAlign: true,
        sortType
    },   
    {
        Header: 'Sold qty (30 days)',
        accessor: 'soldQty',
        disableGlobalFilter: false,
        width: 200,
        rightAlign: true,
        sortType
    },
    {
        Header: 'Velocity',
        accessor: 'velocity',
        disableGlobalFilter: false,
        width: 200,
        rightAlign: true,
        sortType
    },
    {
        Header: 'Average Daily Sold Qty',
        accessor: 'averageDailySoldQty',
        disableGlobalFilter: false,
        width: 180,
        rightAlign: true,
        sortType
    },
    {
        Header: 'Inventory Left (Days)',
        accessor: 'inventoryLeft',
        disableGlobalFilter: false,
        width: 180,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { inventoryLeft } = original;
            let inventoryNum = 0
            if (inventoryLeft?.includes(',')) {
                inventoryNum = Number(inventoryLeft.split(',').join(''))
            } else {
                inventoryNum = Number(inventoryLeft)
            }
            return commonCardForInventory(inventoryLeft, Number(inventoryNum) > Number(prepareStocks)
                ? '#008000' : '#FF0000', '#f9f9f9')
        },
        sortType
    },
    {
        Header: 'Qty to send',
        accessor: 'qtyToSend',
        disableGlobalFilter: false,
        width: 180,
        rightAlign: true,
        sortType
    }    
]

export const tableAdvBudgetPerformance = [{
    Header: 'Compaign Name',
    accessor: 'campaignName',
    disableGlobalFilter: false,
    width: 200,
    sortType
},
{
    Header: 'Country Code',
    accessor: 'countryCode',
    disableGlobalFilter: false,
    width: 100,
    rightAlign: true,
    sortType
},
{
    Header: 'Report Date',
    accessor: 'reportDate',
    disableGlobalFilter: false,
    width: 150,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { reportDate } = original
        return reportDate ? moment(reportDate).format('MM/DD/YYYY') : 'N/A'
    },
    sortType
},
{
    Header: 'Daily Budget',
    accessor: 'dailyBudget',
    disableGlobalFilter: false,
    width: 120,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { dailyBudget } = original
        return setCurrencyFormat(Number(dailyBudget).toFixed(2), true)
    },
    sortType

}, {
    Header: 'Sales',
    accessor: 'sales',
    disableGlobalFilter: false,
    rightAlign: true,
    width: 120,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { sales } = original
        return setCurrencyFormat(Number(sales).toFixed(2), true)
    },
    sortType
}, {
    Header: 'Cost',
    accessor: 'cost',
    disableGlobalFilter: false,
    rightAlign: true,
    width: 120,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { cost } = original
        return setCurrencyFormat(Number(cost).toFixed(2), true)
    },
    sortType
},]


export const tableAdvCampgains = [
    {
        Header: 'Campaign',
        accessor: 'Campaign',
        disableGlobalFilter: false,
        width: 150,
        rightAlign: false,
        sortType
    }, {
        Header: 'Type',
        accessor: 'Type',
        disableGlobalFilter: false,
        width: 200,
        sortType
    },
    {
        Header: 'State',
        accessor: 'State',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: false,
        sortType
    },
    {
        Header: 'Budget',
        accessor: 'Budget',
        disableGlobalFilter: false,
        width: 120,
        rightAlign: true,
        sortType
    }, {
        Header: 'Impressions',
        accessor: 'Impressions',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        sortType
    }, {
        Header: 'Clicks',
        accessor: 'Clicks',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        sortType
    },
    {
        Header: 'Orders',
        accessor: 'Orders',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        sortType
    },
    {
        Header: 'Units',
        accessor: 'Units',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        sortType
    },
    {
        Header: 'Sales',
        accessor: 'Sales',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        sortType
    },
    {
        Header: 'Conversion',
        accessor: 'Conversion',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        sortType
    },
    {
        Header: 'Cost',
        accessor: 'Cost',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        sortType
    }, {
        Header: 'CPC',
        accessor: 'CPC',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        sortType
    }, {
        Header: 'CTR',
        accessor: 'CTR',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        sortType
    }, {
        Header: 'ACOS',
        accessor: 'ACOS',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        sortType
    }, {
        Header: 'ROAS',
        accessor: 'ROAS',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        sortType
    }]

export const tableNewReturnCustomer = [{
    Header: 'Purchase Date',
    accessor: 'purchaseDate',
    disableGlobalFilter: false,
    width: 150,
    sortType
},
{
    Header: 'New Customer Count',
    accessor: 'newCustomersCount',
    disableGlobalFilter: false,
    width: 150,
    rightAlign: true,
    sortType
},
{
    Header: 'Repeated Customer Count',
    accessor: 'repeatedCustomersCount',
    disableGlobalFilter: false,
    width: 150,
    rightAlign: true,
    sortType
},
{
    Header: 'Total Customer Count',
    accessor: 'totalCustomerCount',
    disableGlobalFilter: false,
    width: 150,
    rightAlign: true,
    sortType
},
{
    Header: '% New Customer',
    accessor: 'percentnewCustomer',
    disableGlobalFilter: false,
    width: 150,
    rightAlign: true,
    sortType
}
];

export const tableMonthEndInventory = [{
    Header: 'Date',
    accessor: 'snapShotDate',
    disableGlobalFilter: false,
    width: 250,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { snapShotDate } = original
        return snapShotDate ? moment(snapShotDate).format('MM/DD/YYYY') : 'N/A'
    },
    sortType
},
{
    Header: 'Location',
    accessor: 'location',
    disableGlobalFilter: false,
    width: 300,
    sortType
},
{
    Header: 'SKU',
    accessor: 'sku',
    disableGlobalFilter: false,
    width: 300,
    sortType

},
{
    Header: 'Quantity',
    accessor: 'quantity',
    disableGlobalFilter: false,
    width: 150,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { quantity } = original
        return setCurrencyFormat(Number(quantity).toFixed(2), false)
    },
    sortType
},]

export const tablePromotionByRevenue = [{
    Header: 'Promotion ID',
    accessor: 'promotionID',
    disableGlobalFilter: false,
    width: 600,
    sortType
},
{
    Header: 'Total Promoted Quantity',
    accessor: 'totalQty',
    disableGlobalFilter: false,
    width: 200,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { totalQty } = original
        return setCurrencyFormat(Number(totalQty).toFixed(0), false)
    },
    sortType
},
{
    Header: 'Total Promoted Revenue',
    accessor: 'totalAmount',
    disableGlobalFilter: false,
    width: 200,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { totalAmount } = original
        return setCurrencyFormat(Number(totalAmount).toFixed(2), true)
    },
    sortType
},]


export const tableAdvProducts = [{
    Header: 'SKU',
    accessor: 'sku',
    disableGlobalFilter: false,
    width: 100,
    sortType
},
{
    Header: 'ASIN',
    accessor: 'asin',
    disableGlobalFilter: false,
    width: 100,
    sortType
},
{
    Header: 'Type',
    accessor: 'type',
    disableGlobalFilter: false,
    width: 200,
    sortType
},
{
    Header: 'Impressions',
    accessor: 'impressions',
    disableGlobalFilter: false,
    width: 130,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { impressions } = original
        return setCurrencyFormat(Number(impressions).toFixed(2), false)
    },
    sortType
},
{
    Header: 'Clicks',
    accessor: 'clicks',
    disableGlobalFilter: false,
    width: 100,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { clicks } = original
        return setCurrencyFormat(Number(clicks).toFixed(2), false)
    },
    sortType
},
{
    Header: 'Orders',
    accessor: 'orders',
    disableGlobalFilter: false,
    width: 100,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { orders } = original
        return setCurrencyFormat(Number(orders).toFixed(2), false)
    },
    sortType
},
{
    Header: 'Units',
    accessor: 'units',
    disableGlobalFilter: false,
    width: 100,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { units } = original
        return setCurrencyFormat(Number(units).toFixed(2), false)
    },
    sortType
},
{
    Header: 'Sales',
    accessor: 'sales',
    disableGlobalFilter: false,
    width: 100,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { sales } = original
        return setCurrencyFormat(Number(sales).toFixed(2), true)
    },
    sortType
},
{
    Header: 'Conversion',
    accessor: 'conversion',
    disableGlobalFilter: false,
    width: 130,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { conversion } = original
        return `${setCurrencyFormat(Number(conversion).toFixed(2), false)} %`
    },
    sortType
},
{
    Header: 'Cost',
    accessor: 'cost',
    disableGlobalFilter: false,
    width: 100,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { cost } = original
        return setCurrencyFormat(Number(cost).toFixed(2), true)
    },
    sortType
},
{
    Header: 'CPC',
    accessor: 'cpc',
    disableGlobalFilter: false,
    width: 100,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { cpc } = original
        return setCurrencyFormat(Number(cpc).toFixed(2), true)
    },
    sortType
},
{
    Header: 'CTR',
    accessor: 'ctr',
    disableGlobalFilter: false,
    width: 100,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { ctr } = original
        return `${Number(ctr).toFixed(2)} %`
    },
    sortType
},
{
    Header: 'ACOS',
    accessor: 'acos',
    disableGlobalFilter: false,
    width: 100,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { acos } = original
        return `${Number(acos).toFixed(2)} %`
    },
    sortType
},
{
    Header: 'ROAS',
    accessor: 'roas',
    disableGlobalFilter: false,
    width: 110,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { roas } = original
        return setCurrencyFormat(Number(roas).toFixed(2), false)
    },
    sortType
},]

export const tableAdvKeywords = [{
    Header: 'Type',
    accessor: 'type',
    disableGlobalFilter: false,
    width: 200,
    sortType
},
{
    Header: 'Campaign',
    accessor: 'campaign',
    disableGlobalFilter: false,
    width: 250,
    sortType
},
{
    Header: 'Keyword',
    accessor: 'keyword',
    disableGlobalFilter: false,
    width: 200,
    sortType
},
{
    Header: 'Match',
    accessor: 'match',
    disableGlobalFilter: false,
    width: 100,
    sortType
},
{
    Header: 'Impressions',
    accessor: 'impressions',
    disableGlobalFilter: false,
    width: 130,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { impressions } = original
        return setCurrencyFormat(Number(impressions).toFixed(2), false)
    },
    sortType
},
{
    Header: 'Clicks',
    accessor: 'clicks',
    disableGlobalFilter: false,
    width: 100,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { clicks } = original
        return setCurrencyFormat(Number(clicks).toFixed(2), false)
    },
    sortType
},
{
    Header: 'Orders',
    accessor: 'orders',
    disableGlobalFilter: false,
    width: 100,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { orders } = original
        return setCurrencyFormat(Number(orders).toFixed(2), false)
    },
    sortType
},
{
    Header: 'Units',
    accessor: 'units',
    disableGlobalFilter: false,
    width: 100,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { units } = original
        return setCurrencyFormat(Number(units).toFixed(2), false)
    },
    sortType
},
{
    Header: 'Sales',
    accessor: 'sales',
    disableGlobalFilter: false,
    width: 100,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { sales } = original
        return setCurrencyFormat(Number(sales).toFixed(2), true)
    },
    sortType
},
{
    Header: 'Conversion',
    accessor: 'conversion',
    disableGlobalFilter: false,
    width: 130,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { conversion } = original
        return `${setCurrencyFormat(Number(conversion).toFixed(2), false)} %`
    },
    sortType
},
{
    Header: 'Cost',
    accessor: 'cost',
    disableGlobalFilter: false,
    width: 100,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { cost } = original
        return setCurrencyFormat(Number(cost).toFixed(2), true)
    },
    sortType
},
{
    Header: 'CPC',
    accessor: 'cpc',
    disableGlobalFilter: false,
    width: 100,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { cpc } = original
        return setCurrencyFormat(Number(cpc).toFixed(2), true)
    },
    sortType
},
{
    Header: 'CTR',
    accessor: 'ctr',
    disableGlobalFilter: false,
    width: 100,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { ctr } = original
        return `${Number(ctr).toFixed(2)} %`
    },
    sortType
},
{
    Header: 'ACOS',
    accessor: 'acos',
    disableGlobalFilter: false,
    width: 100,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { acos } = original
        return `${Number(acos).toFixed(2)} %`
    },
    sortType
},
{
    Header: 'ROAS',
    accessor: 'roas',
    disableGlobalFilter: false,
    width: 110,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { roas } = original
        return setCurrencyFormat(Number(roas).toFixed(2), false)
    },
    sortType
},]

export const tableRevenueFromSubscriptionHeader = [
    {
        Header: 'Year',
        accessor: 'salesYear',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 100,
        sortType
    },
    {
        Header: 'Month',
        accessor: 'salesMonth',
        disableGlobalFilter: false,
        width: 100,
        sortType
    },

    {
        Header: 'Sales Channel',
        accessor: 'salesChannel',
        disableGlobalFilter: false,
        width: 180,
        sortType
    },
    {
        Header: 'Order',
        accessor: 'orderCount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { orderCount } = original
            return setCurrencyFormat(Number(orderCount).toFixed(0), false)
        },
        sortType

    },
    {
        Header: 'Amount',
        accessor: 'amount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 130,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { amount } = original
            return setCurrencyFormat(Number(amount).toFixed(2), true)
        },
        sortType
    },

]

export const tablePageTrafficWithConversionHeader = [
    {
        Header: 'Report Date',
        accessor: 'reportDate',
        disableGlobalFilter: false,
        width: 100,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { reportDate } = original
            return moment(reportDate).format('MM-DD-YYYY')
        },
        sortType
    },
    {
        Header: 'SKU',
        accessor: 'sku',
        disableGlobalFilter: false,
        width: 100,
        sortType
    },
    {
        Header: 'ASIN',
        accessor: 'asin',
        disableGlobalFilter: false,
        width: 100,
        sortType
    },

    {
        Header: 'Title',
        accessor: 'title',
        disableGlobalFilter: false,
        width: 280,
        sortType
    },
    {
        Header: 'Sessions',
        accessor: 'sessions',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { sessions } = original
            return setCurrencyFormat(Number(sessions).toFixed(0), false)
        },
        sortType
    },
    {
        Header: 'Sessions Percentage ',
        accessor: 'sessionsPercentage',
        disableGlobalFilter: false,
        width: 150,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { sessionsPercentage } = original
            return `${setCurrencyFormat(Number(sessionsPercentage).toFixed(2), false)} %`
        },
        sortType
    },
    {
        Header: 'Page views',
        accessor: 'pageViews',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { pageViews } = original
            return setCurrencyFormat(Number(pageViews).toFixed(0), false)
        },
        sortType
    },
    {
        Header: 'Pageviews Percentage',
        accessor: 'pageViewsPercentage',
        disableGlobalFilter: false,
        width: 150,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { pageViewsPercentage } = original
            return `${setCurrencyFormat(Number(pageViewsPercentage).toFixed(2), false)} %`
        },
        sortType
    },
    {
        Header: 'Buybox Percentage',
        accessor: 'buyBoxPercentage',
        disableGlobalFilter: false,
        width: 150,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { buyBoxPercentage } = original
            return `${setCurrencyFormat(Number(buyBoxPercentage).toFixed(2), false)} %`
        },
        sortType
    },
    {
        Header: 'Units Ordered',
        accessor: 'unitsOrdered',
        disableGlobalFilter: false,
        width: 150,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { unitsOrdered } = original
            return setCurrencyFormat(Number(unitsOrdered).toFixed(0), false)
        },
        sortType
    },
    {
        Header: 'Units Ordered b2b',
        accessor: 'unitsOrderedB2B',
        disableGlobalFilter: false,
        width: 150,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { unitsOrderedB2B } = original
            return setCurrencyFormat(Number(unitsOrderedB2B).toFixed(0), false)
        },
        sortType
    },
    {
        Header: 'Unit Session Percentage',
        accessor: 'unitSessionPercentage',
        disableGlobalFilter: false,
        width: 150,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { unitSessionPercentage } = original
            return `${setCurrencyFormat(Number(unitSessionPercentage).toFixed(2), false)} %`
        },
        sortType
    },
    {
        Header: 'Unit Session Percentage b2b',
        accessor: 'unitSessionPercentageB2B',
        disableGlobalFilter: false,
        width: 150,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { unitSessionPercentageB2B } = original
            return `${setCurrencyFormat(Number(unitSessionPercentageB2B).toFixed(2), false)} %`
        },
        sortType
    },
    {
        Header: 'Ordered Product Sales',
        accessor: 'orderedProductSales',
        disableGlobalFilter: false,
        width: 150,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { orderedProductSales } = original
            return setCurrencyFormat(Number(orderedProductSales).toFixed(2), true)
        },
        sortType
    },
    {
        Header: 'Ordered Product Sales b2b',
        accessor: 'orderedProductSalesB2B',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { orderedProductSalesB2B } = original
            return setCurrencyFormat(Number(orderedProductSalesB2B).toFixed(2), true)
        },
        sortType
    },
    {
        Header: 'Total Order Items',
        accessor: 'totalOrderItems',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 130,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { totalOrderItems } = original
            return setCurrencyFormat(Number(totalOrderItems).toFixed(0), false)
        },
        sortType
    },
    {
        Header: 'Total Order Items b2b',
        accessor: 'totalOrderItemsB2B',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 130,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { totalOrderItemsB2B } = original
            return setCurrencyFormat(Number(totalOrderItemsB2B).toFixed(0), false)
        },
        sortType
    },
    {
        Header: 'Order Count',
        accessor: 'orderCount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 130,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { orderCount } = original
            return setCurrencyFormat(Number(orderCount).toFixed(0), false)
        },
        sortType
    },

]


export const tableHeaderDataSalesBreakdown = [

    {
        Header: 'Date',
        accessor: 'date',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 100,
        sortType
    },
    {
        Header: 'SKU',
        accessor: 'sku',
        disableGlobalFilter: false,
        width: 130,
        sortType
    },
    {
        Header: 'Product Collection',
        accessor: 'productCollection',
        disableGlobalFilter: false,
        width: 180,
        sortType
    },
    {
        Header: 'Product Category',
        accessor: 'productCategory',
        disableGlobalFilter: false,
        width: 180,
        sortType
    },
    {
        Header: 'Product Sub Category',
        accessor: 'productSubCategory',
        disableGlobalFilter: false,
        width: 200,
        sortType
    },

    {
        Header: 'Sales Channel',
        accessor: 'salesChannel',
        disableGlobalFilter: false,
        width: 180,
        sortType
    },
    {
        Header: 'Order',
        accessor: 'orderCount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        sortType
    },
    {
        Header: 'Amount',
        accessor: 'amount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 130,
        sortType
    },
]

export const filterMonthYearQuarterly = [{
    label: "Monthly", value: "monthly"
}, {
    label: "Yearly", value: "yearly"
},

{
    label: "Quarterly", value: "quarterly"
}]

export const filterShowWiseWithoutSKU = [{
    label: "Product Collection", value: "productCollection"
}, {
    label: "Product Category", value: "productCategory"
},

{
    label: "Product Sub Category", value: "subCategory"
}
]

export const filterShowWiseForBasketAnalysis = [{
    label: "Product Collection", value: "collection"
}, {
    label: "Product Category", value: "category"
},

{
    label: "Product Sub Category", value: "subCategory"
},
{
    label: "SKU Code", value: "sku"
}
]
export const tableBestTimesReport = []


export const tableHeaderDataRevenueFromCustomer = [
    {
        Header: 'Day',
        accessor: 'day',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 100,
        sortType
    },
    {
        Header: 'Month',
        accessor: 'salesMonth',
        disableGlobalFilter: false,
        width: 100,
        sortType
    },
    {
        Header: 'Year',
        accessor: 'salesYear',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 100,
        sortType
    },
    {
        Header: 'Order',
        accessor: 'orderCount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        sortType
    },
    {
        Header: 'SKU',
        accessor: 'sku',
        disableGlobalFilter: false,
        width: 150,
    },
    {
        Header: 'Amount',
        accessor: 'amount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 130,
        sortType
    },
    {
        Header: 'Product Collection',
        accessor: 'productCollection',
        disableGlobalFilter: false,
        width: 180,
        sortType
    },
    {
        Header: 'Product Category',
        accessor: 'productCategory',
        disableGlobalFilter: false,
        width: 180,
        sortType
    },
    {
        Header: 'Product Sub Category',
        accessor: 'productSubCategory',
        disableGlobalFilter: false,
        width: 200,
        sortType
    },

    {
        Header: 'Sales Channel',
        accessor: 'salesChannel',
        disableGlobalFilter: false,
        width: 180,
        sortType
    },
]

export const filterShowWiseForCurrency = [{
    label: "Won", value: "Won"
    // value: "₩"
}, {
    label: "Dollar", value: "Dollar"
    // value: "$"
}]

export const tableHeaderDataForUploadProduct = [
    {
        Header: 'SKU',
        accessor: 'key',
        disableGlobalFilter: false,
        width: 260
    },
    {
        Header: 'Title',
        accessor: 'prouctName',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'Collection',
        accessor: 'productCollection',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'Category',
        accessor: 'productCategory',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'SubCategory',
        accessor: 'productSubCategory',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'Cogs',
        accessor: 'cogs',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
]

export const filterWeeklyMonthYear = [
    {
        label: "Weekly", value: "weekly"
    }, {
        label: "Monthly", value: "monthly"
    }
    , {
        label: "Yearly", value: "yearly"
    }

]

export const sortByOptionsForPOS = [{
    value: 'currentYearMonthMax',
    label: 'Revenue'
}, {
    value: 'title',
    label: 'Company'
},
]

export const tableHeaderDataForUploadPOS = [
    {
        Header: 'SKU',
        accessor: 'key',
        disableGlobalFilter: false,
        width: 260
    },
    {
        Header: 'Description',
        accessor: 'description',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'Sold Qty',
        accessor: 'quantitySold',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 110

    },
    {
        Header: 'Amount',
        accessor: 'amount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 110

    },
    {
        Header: 'Month',
        accessor: 'month',
        disableGlobalFilter: false,
        width: 110

    },
    {
        Header: 'Year',
        accessor: 'year',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 110

    },
    {
        Header: 'Week',
        accessor: 'week',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 110

    },
    {
        Header: 'Company Name',
        accessor: 'companyName',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
]

export const tableHeaderDataForUploadPOSNew = [
    {
        Header: 'Retailer',
        accessor: 'retailer',
        disableGlobalFilter: false,
        width: 160
    },
    {
        Header: 'Week Ending',
        accessor: 'weekEnding',
        disableGlobalFilter: false,
        centerAlign: true,
        width: 150
    },
    {
        Header: 'Product Description',
        accessor: 'productDescription',
        disableGlobalFilter: false,
        width: 260
    },
    {
        Header: 'UPC',
        accessor: 'upc',
        disableGlobalFilter: false,
        width: 160
    },
    {
        Header: 'Door Count',
        accessor: 'doorCount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 140,
        typeof: 'number'
    },
    {
        Header: 'Total Sales ($)',
        accessor: 'totalSalesAmount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 160
    },
    {
        Header: 'Total Units',
        accessor: 'totalUnits',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 140
    },
    {
        Header: 'Store $',
        accessor: 'storeSalesAmount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 140
    },
    {
        Header: 'Store Units',
        accessor: 'storeUnits',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 140
    },
    {
        Header: '.com $',
        accessor: 'dotcomSalesAmount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 140
    },
    {
        Header: '.com Units',
        accessor: 'dotcomUnits',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 140
    },
    {
        Header: 'UPC (New)',
        accessor: 'upcNew',
        disableGlobalFilter: false,
        width: 180
    },
    {
        Header: 'Updated Name',
        accessor: 'updatedName',
        disableGlobalFilter: false,
        width: 220
    },
    {
        Header: 'Category',
        accessor: 'category',
        disableGlobalFilter: false,
        width: 160
    },
    {
        Header: 'Grouped Name',
        accessor: 'groupedName',
        disableGlobalFilter: false,
        width: 200
    },
    {
        Header: 'Description (Trimmed)',
        accessor: 'descriptionTrimmed',
        disableGlobalFilter: false,
        width: 260
    },
    {
        Header: 'Innovation',
        accessor: 'innovation',
        disableGlobalFilter: false,
        centerAlign: true,
        width: 130
    },
    {
        Header: '$PSPW',
        accessor: 'pspwAmount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120
    },
    {
        Header: 'UPSPW',
        accessor: 'upspw',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120
    },
    {
        Header: 'Month',
        accessor: 'month',
        disableGlobalFilter: false,
        width: 150
    },
    {
        Header: 'Year',
        accessor: 'year',
        disableGlobalFilter: false,
        centerAlign: true,
        width: 110
    },
    {
        Header: 'Month / Year',
        accessor: 'monthYear',
        disableGlobalFilter: false,
        centerAlign: true,
        width: 140
    },
    {
        Header: 'Store Count Zero',
        accessor: 'storeCountZero',
        disableGlobalFilter: false,
        centerAlign: true,
        width: 160
    },
    {
        Header: 'Calculated $PSPW',
        accessor: 'calculatedPspwAmount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 170
    },
    {
        Header: 'Calculated UPSPW',
        accessor: 'calculatedUpspw',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 170
    },
    {
        Header: 'Retail Calendar Week',
        accessor: 'retailCalendarWk',
        disableGlobalFilter: false,
        centerAlign: true,
        width: 100
    },
    {
        Header: 'Location',
        accessor: 'location',
        disableGlobalFilter: false,
        centerAlign: true,
        width: 100
    },
]

export const filterDaillyMonthly = [
    {
        label: "Daily", value: "daily"
    }, {
        label: "Monthly", value: "monthly"
    }
]

export const tableShopifyReferrer = [
    //     {
    //     Header: 'ID',
    //     accessor: 'id',
    //     disableGlobalFilter: false,
    //     width: 100,
    //     sortType
    // },
    {
        Header: 'Date',
        accessor: 'date',
        disableGlobalFilter: false,
        width: 150,
        sortType
    },
    {
        Header: 'Referrer Source',
        accessor: 'referrerSource',
        disableGlobalFilter: false,
        width: 250,
        sortType
    },
    {
        Header: 'ReferrerName',
        accessor: 'referrerName',
        disableGlobalFilter: false,
        width: 300,
        sortType
    },
    {
        Header: 'Orders',
        accessor: 'orders',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { orders } = original
            return setCurrencyFormat(Number(orders).toFixed(2), false)
        },
        sortType
    },
    {
        Header: 'Total Sales',
        accessor: 'totalSales',
        disableGlobalFilter: false,
        width: 200,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { totalSales } = original
            return setCurrencyFormat(Number(totalSales).toFixed(2), true)
        },
        sortType
    },
]
export const sortByOptionsForShopifyRefferer = [{
    value: 'currentYearMonthMax',
    label: 'Total Sales'
}, {
    value: 'title',
    label: 'Refferer'
},
]

export const tableShopifySessionReferrer = [
    //     {
    //     Header: 'ID',
    //     accessor: 'id',
    //     disableGlobalFilter: false,
    //     width: 100,
    //     sortType
    // },
    {
        Header: 'Date',
        accessor: 'date',
        disableGlobalFilter: false,
        width: 150,
        sortType
    },
    {
        Header: 'Referrer Source',
        accessor: 'referrerSource',
        disableGlobalFilter: false,
        width: 250,
        sortType
    },
    {
        Header: 'ReferrerName',
        accessor: 'referrerName',
        disableGlobalFilter: false,
        width: 300,
        sortType
    },
    {
        Header: 'Total Visitors',
        accessor: 'totalVisitors',
        disableGlobalFilter: false,
        width: 100,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { totalVisitors } = original
            return setCurrencyFormat(Number(totalVisitors).toFixed(0), false)
        },
        sortType
    },
    {
        Header: 'Total Sessions',
        accessor: 'totalSessions',
        disableGlobalFilter: false,
        width: 200,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { totalSessions } = original
            return setCurrencyFormat(Number(totalSessions).toFixed(0), false)
        },
        sortType
    },
]
export const tableShopifySessionChannel = [
    //     {
    //     Header: 'ID',
    //     accessor: 'id',
    //     disableGlobalFilter: false,
    //     width: 100,
    //     sortType
    // },
    {
        Header: 'Date',
        accessor: 'date',
        disableGlobalFilter: false,
        width: 150,
        sortType
    },
    {
        Header: 'Channel',
        accessor: 'channel',
        disableGlobalFilter: false,
        width: 250,
        sortType
    },
    {
        Header: 'Orders',
        accessor: 'orders',
        disableGlobalFilter: false,
        width: 120,
        sortType
    },
    {
        Header: 'Gross Sales',
        accessor: 'grossSales',
        disableGlobalFilter: false,
        width: 150,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { grossSales } = original
            return setCurrencyFormat(Number(grossSales).toFixed(2), true)
        },
        sortType
    },
    {
        Header: 'Discounts',
        accessor: 'discounts',
        disableGlobalFilter: false,
        width: 200,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { discounts } = original
            return setCurrencyFormat(Number(discounts).toFixed(2), true)
        },
        sortType
    },
    {
        Header: 'Returns',
        accessor: 'returns',
        disableGlobalFilter: false,
        width: 200,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { returns } = original
            return setCurrencyFormat(Number(returns).toFixed(2), false)
        },
        sortType
    },
    {
        Header: 'Net Sales',
        accessor: 'netSales',
        disableGlobalFilter: false,
        width: 200,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { netSales } = original
            return setCurrencyFormat(Number(netSales).toFixed(2), true)
        },
        sortType
    },
    {
        Header: 'Shipping',
        accessor: 'shipping',
        disableGlobalFilter: false,
        width: 200,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { shipping } = original
            return setCurrencyFormat(Number(shipping).toFixed(2), true)
        },
        sortType
    },
    {
        Header: 'Taxes',
        accessor: 'taxes',
        disableGlobalFilter: false,
        width: 200,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { taxes } = original
            return setCurrencyFormat(Number(taxes).toFixed(2), true)
        },
        sortType
    },
    {
        Header: 'Total Sales',
        accessor: 'totalSales',
        disableGlobalFilter: false,
        width: 200,
        rightAlign: true,
        Cell: ({ cell: { row: { original } } }) => {
            // eslint-disable-next-line react/prop-types
            const { totalSales } = original
            return setCurrencyFormat(Number(totalSales).toFixed(2), true)
        },
        sortType
    },
]
export const tableHeaderDataVirtualBundleSales = [
    {
        Header: 'DATE',
        accessor: 'date',
        disableGlobalFilter: false,
        width: 150,
        sortType
    },
    {
        Header: 'BUNDLE_ASIN',
        accessor: 'asin',
        disableGlobalFilter: false,
        width: 200,
        sortType
    },
    {
        Header: 'TITLE',
        accessor: 'title',
        disableGlobalFilter: false,
        width: 350,
        sortType
    },
    {
        Header: 'BUNDLES_SOLD',
        accessor: 'soldQuantity',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 180,
        sortType
    },
    {
        Header: 'TOTAL_SALES',
        accessor: 'amount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 150,
        sortType
    },

    
]

export const tablePromotionPrime = [{
    Header: 'SKU',
    accessor: 'sku',
    disableGlobalFilter: false,
    width: 200,
    sortType
},
{
    Header: 'Name',
    accessor: 'name',
    disableGlobalFilter: false,
    width: 600,
    sortType
},
{
    Header: 'Total Promoted Quantity',
    accessor: 'totalQty',
    disableGlobalFilter: false,
    width: 200,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { totalQty } = original
        return setCurrencyFormat(Number(totalQty).toFixed(0), false)
    },
    sortType
},
{
    Header: 'Total Promoted Revenue',
    accessor: 'totalAmount',
    disableGlobalFilter: false,
    width: 200,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { totalAmount } = original
        return setCurrencyFormat(Number(totalAmount).toFixed(2), true)
    },
    sortType
},]

export const tableHeaderDataForUploadOrder = [
    {
        Header: 'amazon-order-id',
        accessor: 'amazonOrderId',
        disableGlobalFilter: false,
        width: 260
    },
    {
        Header: 'merchant-order-id',
        accessor: 'merchantOrderId',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'purchase-date',
        accessor: 'purchaseDate',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'last-updated-date',
        accessor: 'lastUpdatedDate',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'order-status',
        accessor: 'orderStatus',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'fulfillment-channel',
        accessor: 'fulfillmentChannel',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'sales-channel',
        accessor: 'salesChannel',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'order-channel',
        accessor: 'orderChannel',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'url',
        accessor: 'url',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'ship-service-level',
        accessor: 'shipServiceLevel',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'product-name',
        accessor: 'productName',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 600

    },
    {
        Header: 'sku',
        accessor: 'sku',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'asin',
        accessor: 'asin',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'item-status',
        accessor: 'itemStatus',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'quantity',
        accessor: 'quantity',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'currency',
        accessor: 'currency',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'item-price',
        accessor: 'itemPrice',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'item-tax',
        accessor: 'itemTax',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'shipping-price',
        accessor: 'shippingPrice',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'shipping-tax',
        accessor: 'shippingTax',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'gift-wrap-price',
        accessor: 'giftWrapPrice',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'gift-wrap-tax',
        accessor: 'giftWrapTax',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'item-promotion-discount',
        accessor: 'itemPromotionDiscount',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'ship-promotion-discount',
        accessor: 'shipPromotionDiscount',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'ship-city',
        accessor: 'shipCity',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'ship-state',
        accessor: 'shipState',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'ship-postal-code',
        accessor: 'shipPostalCode',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'ship-country',
        accessor: 'shipCountry',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'promotion-ids',
        accessor: 'promotionIds',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'is-business-order',
        accessor: 'isBusinessOrder',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'purchase-order-number',
        accessor: 'purchaseOrderNumber',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'price-designation',
        accessor: 'cogs',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'is-iba',
        accessor: 'isIba',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'buyer-citizen-name',
        accessor: 'buyerCitizenName',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'buyer-citizen-id',
        accessor: 'buyerCitizenId',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'order-invoice-type',
        accessor: 'orderInvoiceType',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'invoice-business-legal-name',
        accessor: 'invoiceBusinessLegalName',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'invoice-business-address',
        accessor: 'invoiceBusinessAddress',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'invoice-business-tax-id',
        accessor: 'invoiceBusinessTaxId',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'invoice-business-tax-office',
        accessor: 'invoiceBusinessTaxOffice',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
]

export const tableImportOrderStatusHeader = [{
    Header: 'Date Time',
    accessor: 'dateTime',
    disableGlobalFilter: false,
    width: 180,    
    sortType
},{
    Header: 'File Name',
    accessor: 'fileName',
    disableGlobalFilter: false,
    width: 400,
    sortType
}
,{
    Header: 'Total Record Process',
    accessor: 'recordsProcessed',
    disableGlobalFilter: false,
    width: 200,
    sortType
},{
    Header: 'Processing Time',
    accessor: 'processingTime',
    disableGlobalFilter: false,
    width: 180,
    sortType
},
{
    Header: 'Status',
    accessor: 'status',
    disableGlobalFilter: false,
    centerAlign:true,
    width: 200,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { status } = original
        let result = ''
        if(status === "FAILURE") {
            result = <div className='badge badge-danger item-center'>{status}</div>
        } 
        else if (status === "SUCCESS") 
        {
            result = <div className='badge badge-success'>{status}</div>
        }
        else {
            result = <div className='badge badge-warning'>{status}</div>
        }
        return result        
    },
    sortType
},
]

export const tableDataIngestionBatchStatus = [{
    Header: 'BatchID',
    accessor: 'batchId',
    disableGlobalFilter: false,
    width: 120,
    sortType
},
{
    Header: 'Date',
    accessor: 'batchDate',
    disableGlobalFilter: false,
    width: 120,
    sortType
},
{
    Header: 'Process Id',
    accessor: 'lineItemId',
    disableGlobalFilter: false,
    width: 120,
    rightAlign: true,
    sortType
},
{
    Header: 'Process Description',
    accessor: 'lineItemDesc',
    disableGlobalFilter: false,
    width: 180,
    sortType
},
{
    Header: 'Region',
    accessor: 'region',
    disableGlobalFilter: false,
    width: 120,
    rightAlign: true,    
    sortType
},
{
    Header: 'Total Time Taken',
    accessor: 'totalTimeTaken',
    disableGlobalFilter: false,
    width: 160, 
    rightAlign: true,  
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { totalTimeTaken } = original
        console.log(totalTimeTaken)
        let formattedTime = ''
        if(totalTimeTaken == null){
            formattedTime = '00:00:00'
        }
        else {
            const [h, m, s] = totalTimeTaken.split(':').map(Number);
            const seconds = (h * 60 * 60) + (m * 60) + s;
            formattedTime = new Date(seconds * 1000).toISOString().substr(11, 8);
            
        }
        return formattedTime
    },
    sortType
},
{
    Header: 'Status',
    accessor: 'status',
    disableGlobalFilter: false,
    width: 140,
    centerAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { status } = original
        let result = ''
        if(status.toUpperCase() === "FAILURE") {
            result = <div className='badge badge-danger item-center'>{status}</div>
        } 
        else if (status.toUpperCase() === "SUCCESS") 
        {
            result = <div className='badge badge-success'>{status}</div>
        }
        else {
            result = <div className='badge badge-warning'>{status}</div>
        }
        return result        
    },
    sortType
},
{
    Header: 'Records Processed',
    accessor: 'numberOfRecords',
    disableGlobalFilter: false,
    width: 170,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { numberOfRecords } = original
        return setCurrencyFormat(Number(numberOfRecords), false)
    },
    sortType
},
{
    Header: 'Batch Start At',
    accessor: 'batchStartAt',
    disableGlobalFilter: false,
    width: 150,    
    sortType
},
{
    Header: 'Batch End At',
    accessor: 'batchEndAt',
    disableGlobalFilter: false,
    width: 150,    
    sortType
},
{
    Header: 'Other Detail',
    accessor: 'otherDetails',
    disableGlobalFilter: false,
    width: 150,    
    sortType
},
{
    Header: 'Mark As',
    accessor: 'markAs',
    disableGlobalFilter: false,
    width: 120,
    rightAlign: true,    
    sortType
},
]

export const searchPositionTrackerTableHeader = [
    // {
    //     Header: 'Title',
    //     accessor: 'title',
    //     disableGlobalFilter: false,
    //     width: 150,
    //     sortType
    // },
    // {
    //     Header: 'ASIN',
    //     accessor: 'asin',
    //     disableGlobalFilter: false,
    //     width: 200,
    //     sortType
    // },
    {
        Header: 'Keyword',
        accessor: 'keyword',
        disableGlobalFilter: false,
        // rightAlign: true,
        width: 220,
        sortType
    },
    {
        Header: 'Search Volume',
        accessor: 'searchVolume',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 150,
        sortType
    },
    {
        Header: 'Keyword Sales',
        accessor: 'keywordSales',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 150,
        sortType
    },   
    {
        Header: 'Type',
        accessor: 'type',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 150,
        sortType
    }, 
    // {
    //     Header: 'Marketplace',
    //     accessor: 'marketplace',
    //     disableGlobalFilter: false,
    //     rightAlign: true,
    //     width: 150,
    //     sortType
    // },
    
    
    // {
    //     Header: 'Sponsored Position',
    //     accessor: 'sponsoredPosition',
    //     disableGlobalFilter: false,
    //     rightAlign: true,
    //     width: 150,
    //     sortType
    // },
    // {
    //     Header: 'Date Added',
    //     accessor: 'date',
    //     disableGlobalFilter: false,
    //     rightAlign: true,
    //     width: 150,
    //     sortType
    // },   
    
]

export const sortByOptionsForSearchTracker = [{
    value: 'searchVolume',
    label: 'Search Volume'
}, {
    value: 'keywordSales',
    label: 'Keyword Sales'
},
{
    value: 'keyword',
    label: 'Keywords'
}
]

export const tableHeaderDataForUploadFullfillmentShipment = [
    {
        Header: 'amazon-order-id',
        accessor: 'amazonOrderId',
        disableGlobalFilter: false,
        width: 260
    },
    {
        Header: 'merchant-order-id',
        accessor: 'merchantOrderId',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'shipment-id',
        accessor: 'shipmentId',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'shipment-item-id',
        accessor: 'shipmentItemId',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'amazon-order-item-id',
        accessor: 'amazonOrderItemId',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'merchant-order-item-id',
        accessor: 'merchantOrderItemId',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'purchase-date',
        accessor: 'purchaseDate',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'payments-date',
        accessor: 'paymentsDate',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'shipment-date',
        accessor: 'shipmentDate',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'reporting-date',
        accessor: 'reportingDate',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'buyer-email',
        accessor: 'buyerEmail',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 260

    },
    {
        Header: 'buyer-name',
        accessor: 'buyerName',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'buyer-phone-number',
        accessor: 'buyerPhoneNumber',
        disableGlobalFilter: false,        
        width: 200

    },
    {
        Header: 'merchant-sku',
        accessor: 'merchantSku',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'title',
        accessor: 'title',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 600

    },
    {
        Header: 'shipped-quantity',
        accessor: 'shippedQuantity',
        disableGlobalFilter: false,
        rightAlign: true,       
        width: 200

    },
    {
        Header: 'currency',
        accessor: 'currency',
        disableGlobalFilter: false,       
        centerAlign: true,
        width: 200

    },
    {
        Header: 'item-price',
        accessor: 'itemPrice',
        disableGlobalFilter: false,
        rightAlign: true,      
        width: 200

    },
    {
        Header: 'item-tax',
        accessor: 'itemTax',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'shipping-price',
        accessor: 'shippingPrice',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'shipping-tax',
        accessor: 'shippingTax',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'gift-wrap-price',
        accessor: 'giftWrapPrice',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'gift-wrap-tax',
        accessor: 'giftWrapTax',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'ship-service-level',
        accessor: 'shipServiceLevel',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'recipient-name',
        accessor: 'recipientName',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'shipping-address1',
        accessor: 'shippingAddress1',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'shipping-address2',
        accessor: 'shippingAddress2',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'shipping-address3',
        accessor: 'shippingAddress3',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'shipping-city',
        accessor: 'shippingCity',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'shipping-state',
        accessor: 'shippingState',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'shipping-postal-code',
        accessor: 'shippingPostalCode',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'shipping-country-code',
        accessor: 'shippingCountryCode',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'shipping-phone-number',
        accessor: 'shippingPhoneNumber',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'billing-address1',
        accessor: 'billingAddress1',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'billing-address2',
        accessor: 'billingAddress2',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'billing-address3',
        accessor: 'billingAddress3',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'billing-city',
        accessor: 'billingCity',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'billing-state',
        accessor: 'billingState',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'billing-postal-code',
        accessor: 'billingPostalCode',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'billing-country',
        accessor: 'billingCountry',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'item-promo-discount',
        accessor: 'itemPromoDiscount',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'shipment-promo-discount',
        accessor: 'shipmentPromoDiscount',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'carrier',
        accessor: 'carrier',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'tracking-number',
        accessor: 'trackingNumber',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'estimated-arrival-date',
        accessor: 'estimatedArrivalDate',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'fc',
        accessor: 'fc',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'fulfillment-channel',
        accessor: 'fulfillmentChannel',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
    {
        Header: 'sales-channel',
        accessor: 'salesChannel',
        disableGlobalFilter: false,
        // rightAlign: true,
        centerAlign: true,
        width: 200

    },
]

export const tableImportFullfillmentShipmentStatusHeader = [{
    Header: 'Date Time',
    accessor: 'dateTime',
    disableGlobalFilter: false,
    width: 180,    
    sortType
},{
    Header: 'File Name',
    accessor: 'fileName',
    disableGlobalFilter: false,
    width: 400,
    sortType
}
,{
    Header: 'Total Record Process',
    accessor: 'recordsProcessed',
    disableGlobalFilter: false,
    width: 200,
    sortType
},{
    Header: 'Processing Time',
    accessor: 'processingTime',
    disableGlobalFilter: false,
    width: 180,
    sortType
},
{
    Header: 'Status',
    accessor: 'status',
    disableGlobalFilter: false,
    centerAlign:true,
    width: 200,
    Cell: ({ cell: { row: { original } } }) => {
        // eslint-disable-next-line react/prop-types
        const { status } = original
        let result = ''
        if(status === "FAILURE") {
            result = <div className='badge badge-danger item-center'>{status}</div>
        } 
        else if (status === "SUCCESS") 
        {
            result = <div className='badge badge-success'>{status}</div>
        }
        else {
            result = <div className='badge badge-warning'>{status}</div>
        }
        return result        
    },
    sortType
},
]

export const performanceBySKUtype = [
    {
      title: "Sales",
      value: "salesAmount"
    },
    {
      title: "Profits",
      value: "profit"
    },
    {
      title: "Orders",
      value: "ordersCount"
    },
    {
      title: "Units",
      value: "units"
    },
    {
      title: "Organic orders",
      value: "organicOrders"
    },
    {
      title: "Organic Units",
      value: "organicUnits"
    },
    {
      title: "Promotions",
      value: "promotions"
    },
    {
      title: "Refunds",
      value: "refunds"
    },
    {
      title: "Sessions",
      value: "sessions"
    },
    {
      title: "Conversion",
      value: "conversions"
    },
    {
      title: "Unit Sessions %",
      value: "unitSessionPercentage"
    },
    {
      title: "PPC Sales %",
      value: "ppcSalesPercentage"
    },
    {
      title: "PPC Orders",
      value: "ppcOrders"
    },
    {
      title: "PPC Units",
      value: "ppcUnits"
    },
    {
      title: "PPC Sales",
      value: "ppcSales"
    },
    {
      title: "PPC Cost",
      value: "ppcCost"
    },
    {
      title: "PPC Impression",
      value: "ppcImpressions"
    },
    {
      title: "PPC Clicks",
      value: "ppcClicks"
    },
    {
      title: "PPC Cost Per Click",
      value: "ppcCostPerClick"
    },
    {
      title: "PPC Conversion",
      value: "ppcConversion"
    },
    {
      title: "PPC Cost Per Order",
      value: "ppcCostPerOrder"
    },
    {
      title: "ACOS",
      value: "acos"
    },
    {
      title: "TACOS %",
      value: "tacosPercentage"
    },
    {
      title: "Margin %",
      value: "marginPercentage"
    }  
  ]

export const sortByOptionsForRefund = [{
    value: 'currentYearMonthMax',
    label: 'Order Count'
}, {
    value: 'currentYearMonthRefundMax',
    label: 'Refund Order Count'
},{
    value: 'title',
    label: 'Description'
},
]

export const filterShowDayMonth = [{
    label: "Day", value: "daily"
}, {
    label: "Month", value: "monthly"
}]

export const tableHeaderDataReturnRefund = [
    {
        Header: 'Day',
        accessor: 'day',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 100,
        sortType
    },
    {
        Header: 'Month',
        accessor: 'salesMonth',
        disableGlobalFilter: false,
        width: 100,
        sortType
    },
    {
        Header: 'Year',
        accessor: 'salesYear',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 100,
        sortType
    },
    {
        Header: 'Order',
        accessor: 'orderCount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 120,
        sortType
    },
    {
        Header: 'SKU',
        accessor: 'sku',
        disableGlobalFilter: false,
        width: 150,
    },
    {
        Header: 'Refund Order',
        accessor: 'refundOrderCount',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 130,
        sortType
    },
    {
        Header: 'Product Collection',
        accessor: 'productCollection',
        disableGlobalFilter: false,
        width: 180,
        sortType
    },
    {
        Header: 'Product Category',
        accessor: 'productCategory',
        disableGlobalFilter: false,
        width: 180,
        sortType
    },
    {
        Header: 'Product Sub Category',
        accessor: 'productSubCategory',
        disableGlobalFilter: false,
        width: 200,
        sortType
    },

    {
        Header: 'Sales Channel',
        accessor: 'salesChannel',
        disableGlobalFilter: false,
        width: 180,
        sortType
    },
]

export const tableHeaderDataTax = [
    {
        Header: 'State',
        accessor: 'state',
        disableGlobalFilter: false,
        width: 150,
        sortType
    },
    {
        Header: 'ZipCode',
        accessor: 'zipCode',
        disableGlobalFilter: false,
        width: 200,
        sortType
    },
    {
        Header: 'Sales',
        accessor: 'sales',
        disableGlobalFilter: false,
        width: 350,
        sortType
    },
    {
        Header: 'TaxPaid',
        accessor: 'taxPaid',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 180,
        sortType
    },    
]
    

export const tableHeaderDataForUploadSubscriber = [
    {
        Header: 'ASIN',
        accessor: 'asin',
        disableGlobalFilter: false,
        width: 260
    },
    {
        Header: 'SKU',
        accessor: 'sku',
        disableGlobalFilter: false,
        width: 260
    },
    {
        Header: 'Product name',
        accessor: 'productName',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'Subscriptions Count',
        accessor: 'activeSubscriptions',
        disableGlobalFilter: false,
        width: 260

    },
    {
        Header: 'Country',
        accessor: 'country',
        disableGlobalFilter: false,
        width: 260
    }
]
